import React from "react";
import util from "../../../lib/util";
import DayPicker from "react-day-picker";
import moment from "moment";
import { VIEW_MODE } from "./_common";

/**
 * @typedef {{
 *  startDate: Moment,
 *  endDate: Moment
 * }} DateRange
 * 
 * @typedef {{
 *  value: Moment | string, 
 * }} PtoWeekPickerProps
 */

function getText(m, selectionMode) {
    return selectionMode === VIEW_MODE.WEEK ? getDateText(m) : getMonthText(m);
}

function getMonthText(m) {
    return m.format("MMMM YYYY");
}

function getDateText(m) {
    return m.format("MMMM DD, YYYY");
}

export default class PtoCalendarViewDatePicker extends React.Component {
    /**
     * 
     * @param {_WeekPickerProps} props 
     */
    constructor(props) {
        super(props);

        const selectionMode = props.selectionMode;

        /** @type {DateRange} */
        const range = selectionMode === VIEW_MODE.WEEK ? util.getWeekRangeOf(props.value) : util.getMonthRangeOf(props.value);
        const selectedDays = util.getAllDaysInRange(range.startDate, range.endDate).map(v => v.toDate());
        const mMonth = moment(selectedDays[0]);
        this.state = {
            selectedDays,
            month: mMonth.toDate(),
            monthText: getText(mMonth, selectionMode)
        };

        this._setSelectedDays = this._setSelectedDays.bind(this);
        this._next = this._next.bind(this);
        this._previous = this._previous.bind(this);
    }

    componentDidMount() {
        const selectionMode = this.props.selectionMode;

        /** @type {DayPicker} */
        const picker = this.refs.dayPicker;
        $(".pto-week-picker .DayPicker-NavButton--prev").click(evt => {
            const prevMonth = moment(this.state.month).subtract(1, "month");
            this.setState({
                month: prevMonth.toDate(),
                monthText: getText(prevMonth, selectionMode)
            });
            evt.preventDefault();
            evt.stopPropagation();
            return false;
        })

        $(".pto-week-picker .DayPicker-NavButton--next").click(evt => {
            const nextMonth = moment(this.state.month).add(1, "month");
            this.setState({
                month: nextMonth.toDate(),
                monthText: getText(nextMonth, selectionMode)
            });
            evt.preventDefault();
            evt.stopPropagation();
            return false;
        })
    }

    _setSelectedDays(date) {
        const selectionMode = this.props.selectionMode;
        const { props, state } = this;
        const mDate = moment(date);
        const mMonth = moment(mDate);
        mMonth.startOf("month");

        //if (props.selectionMode === VIEW_MODE.MONTH && mMonth.toDate().valueOf() === state.month.valueOf()) return;

        const range = props.selectionMode === VIEW_MODE.WEEK ? util.getWeekRangeOf(mDate) : util.getMonthRangeOf(mDate);

        const selectedDays = util.getAllDaysInRange(range.startDate, range.endDate).map(v => v.toDate());
        this.setState({
            selectedDays,
            month: mMonth.toDate(),
            monthText: getText(range.startDate, selectionMode)
        });
        this._fireOnChange(selectedDays);
    }

    _next() {
        const mDate = moment(this.state.selectedDays[0]);
        const unit = this.props.selectionMode === VIEW_MODE.WEEK ? "week" : "month";
        mDate.add(1, unit);
        this._setSelectedDays(mDate);
    }

    _previous() {
        const mDate = moment(this.state.selectedDays[0]);
        const unit = this.props.selectionMode === VIEW_MODE.WEEK ? "week" : "month";
        mDate.subtract(1, unit);
        this._setSelectedDays(mDate);
    }

    _fireOnChange(selectedDays) {
        if (this.props.onChange) this.props.onChange(selectedDays);
    }

    render() {

        return (
            <div className="form-group-sm ap-horiz-margin-5">
                <div className="">
                    <span className="ap-minor-btn fa fa-caret-left ap-clickable " onClick={this._previous}></span>
                    <span className="ap-minor-btn fa fa-caret-right ap-clickable ap-horiz-margin-5" onClick={this._next}></span>
                    <div className="input-group input-group-sm ap-inline-flex row-flex dropdown ap-vert-align-top ap-dropdown">
                        <button ref="toggleButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style={{ width: 150 }}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <span type="text" className="dropdown-label ap-unwrap-content" style={{ fontSize: 12 }}>{this.state.monthText}</span>
                                <span className="input-group-addon fa fa-caret-down ap-clickable ap-addon-button dropdown-toggler"></span>
                            </div>
                        </button>
                        <div className="dropdown-menu">
                            <DayPicker
                                className="pto-week-picker"
                                mode="multiple"
                                ref="dayPicker"
                                showOutsideDays
                                enableOutsideDaysClick
                                month={this.state.month}
                                selectedDays={this.state.selectedDays}
                                onDayClick={this._setSelectedDays}
                                modifiersStyles={{
                                    outside: {
                                        color: "#CCC"
                                    },
                                    selected: {
                                        borderRadius: "0px",
                                        backgroundColor: "#829663",
                                        color: "white"
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
